import {createStandardAction} from "typesafe-actions";
import {IReport, ISharedEntryPoint} from "./types";
import IAnalyticsAction from "./analytics/IAnalyticsAction";

export const gameInit = createStandardAction("@system/GAME_INIT")<ISharedEntryPoint | null>();
export const gameReset = createStandardAction("@system/GAME_RESET")();
export const gameSynchronized = createStandardAction("@system/GAME_SYNCHRONIZED")();

export const trackAction = createStandardAction("@system/TRACK_ACTION")<IAnalyticsAction>();

export const sendReport = createStandardAction("@system/SEND_REPORT")<IReport>();